export default __webpack_public_path__ + "static/override-ui-a11527b12582e3bc618e417c706bc214.png";